import AcceptModal from "./AcceptModal"
import RejectModal from "./RejectModal"

const ApprovalModal = ({
    show,
    handleClose,
    isAccept,
    user,
    setLoadingPage
}) => {
    return(
        <>
            {
                isAccept?
                <AcceptModal
                    show={show}
                    handleClose={handleClose}
                    user={user}
                    setLoadingPage={setLoadingPage}
                />:
                <RejectModal
                    show={show}
                    handleClose={handleClose}
                    user={user}
                    setLoadingPage={setLoadingPage}
                />
            }
        </>
    )
}

export default ApprovalModal